<template>
  <svg
    viewBox="0 0 389 389"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-full h-full"
  >
    <rect
      width="388.631"
      height="388.631"
      rx="115.222"
      fill="#01D680"
    />
    <path
      d="M146.965 133.273C151.986 128.173 151.921 119.969 146.821 114.948L120.238 88.7791C115.138 83.7588 115.074 75.5547 120.094 70.4549L150.932 39.1291C155.952 34.0293 164.156 33.9651 169.256 38.9854C206.715 75.8609 243.984 112.549 281.477 149.458C302.817 170.465 313.754 198.352 313.968 225.538C314.44 285.662 258.419 342.569 197.777 343.568C170.331 344.045 142.795 333.02 121.455 312.012C79.0378 270.256 78.7677 202.55 120.524 160.133L146.965 133.273ZM202.043 235.854C197.527 241.275 189.503 242.086 183.994 237.678L165.303 222.726C150.549 208.202 199.635 211.282 165.303 222.726C172.943 230.247 184.506 226.135 193.913 225.538C215.352 225.893 207.436 224.657 207.264 202.699C207.607 198.006 215.46 198.698 222.587 199.799C230.078 200.956 228.817 203.718 223.965 209.542L202.043 235.854Z"
      fill="#043F42"
    />
    <path
      d="M203.581 180.758C224.336 180.758 243.824 191.559 253.99 209.286C257.178 214.846 253.002 220.927 247.335 221.535L224.34 224.003C221.924 224.262 219.657 223.497 217.857 222.259L217.503 222.005C213.408 218.942 208.798 217.417 203.581 217.417C192.375 217.417 182.265 225.434 182.265 236.27C182.265 247.459 192.405 255.45 203.581 255.45C208.787 255.45 213.374 253.933 217.451 250.797C219.319 249.36 221.771 248.425 224.405 248.708L247.335 251.169C253.004 251.777 257.177 257.857 253.995 263.417C243.836 281.168 224.351 292.109 203.581 292.109C172.646 292.109 145.606 268.195 145.606 236.27C145.606 204.492 172.664 180.758 203.581 180.758Z"
      fill="#01D680"
      stroke="#01D680"
      stroke-width="5.63307"
    />
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
